// Open the menu when the open button is clicked
var menuOpen = document.getElementsByClassName('js-menu-open')[0];
menuOpen.onclick = function() {
  document.getElementsByClassName('menu')[0].classList.add('is-open');
}

// Close the menu when the close button is clicked
var menuClose = document.getElementsByClassName('js-menu-close')[0];
menuClose.onclick = function() {
  document.getElementsByClassName('menu')[0].classList.remove('is-open');
}

// Close the menu when the overlay is clicked
var menuOverlay = document.getElementsByClassName('js-menu-overlay')[0];
menuOverlay.onclick = function() {
  document.getElementsByClassName('menu')[0].classList.remove('is-open');
}

// Close the menu when a menu link is clicked
var menuLinks = document.getElementsByClassName('js-menu-link');
for (var i = 0; i < menuLinks.length; i++) {
  var menuLink = menuLinks[i];
  menuLink.onclick = function() {
    document.getElementsByClassName('menu')[0].classList.remove('is-open');
  }
}

// Add smooth scrolling to menu links
document.querySelectorAll('a[href^="#"]').forEach(anchor => {
  anchor.addEventListener('click', function (e) {
    e.preventDefault();
    document.querySelector(this.getAttribute('href')).scrollIntoView({
      behavior: 'smooth'
    });
  });
});
